import { useGetNonSalesBonusReport } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function NonSalesBonusReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      title={t('common:non-sales-bonus-report')}
      usePivotQuery={useGetNonSalesBonusReport}
      completeName={['bonus_period', 'employee']}
    />
  );
}
